module.exports = __webpack_public_path__ + "img/ball_crank_handle.prt.88aba6fd.jpg";